import _ from 'lodash';
import React, { useState, useEffect, useMemo } from 'react';
import { withTranslation,Trans } from 'react-i18next';
import ProfileStore from '@/stores/ProfileStore';

import ChatIcon from './ChatIcon';
import PhoneIcon from './PhoneIcon';
import EmailIcon from './EmailIcon';

import { ReactComponent as LiveChatIcon } from '@/img/contact_us_page/live-chat.svg';
import { ReactComponent as ILFlagIcon } from '@/img/contact_us_page/il-flag.svg';
import { ReactComponent as UKFlagIcon } from '@/img/contact_us_page/uk-flag.svg';
import { ReactComponent as USFlagIcon } from '@/img/contact_us_page/us-flag.svg';
import { ReactComponent as PHFlagIcon } from '@/img/contact_us_page/ph-flag.svg';
import { ReactComponent as OperatingHoursIcon } from '@/img/contact_us_page/operating-hours.svg';

const Hours = ({ children }) => {
  return <span className="hours-value">{children}</span>;
};
const getFlagIconByPhoneNumber = (tel) => {
  if (tel.startsWith('+44')) return <UKFlagIcon />;
  if (tel.startsWith('+1')) return <USFlagIcon />;
  if (tel.startsWith('+63')) return <PHFlagIcon />;
  if (tel.startsWith('+972') || tel.startsWith('03')) return <ILFlagIcon />;
};

const ContactCard = ({ icon, title, children }) => (
  <div className="contact-card">
    <div className="cc-icon">{icon}</div>
    <div className="cc-content">
      <div className="contact-card-title">{title}</div>
      <div className="contact-card-content">{children}</div>
    </div>
  </div>
);

const ContactUsPage = ({ t }) => {
  const profile = ProfileStore.getProfile();
  const isChatEnabled = _.get(profile, 'chat_enabled', false) && _.get(profile, 'isLoggedIn', false);

  const HelpEmail = t('HelpEmail');
  const showPhoneCard = t('SupportPhoneNumber') || t('ILPhone') || t('UKPhone') || t('USPhone') || t('PHPhone');

  const operatingHours = useMemo(
    () =>  {
      if(t('OperatingHours') !== "OperatingHours"){
        return [
            { key: t('OperatingHours.SunToThu') },
            { key: t('OperatingHours.FridayAndHoliday')},
            { key: t('OperatingHours.SatNight')},
          ].filter(h=>h.key.trim())
      }

      return [];
      },[t]);

  const ChatCardContent = ({ t }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    if (window.zE) {
      window.zE('messenger:on', 'open', () => setIsChatOpen(true));
      window.zE('messenger:on', 'close', () => setIsChatOpen(false));
    }
  }, []);

  const toggleChat = () => {
    if (!window.zE) return;
    isChatOpen ? window.zE('messenger', 'close') : window.zE('messenger', 'open');
  };

  return (
    <div className="chat-content">
    	<button className="live-chat" onClick={toggleChat}>
      		<LiveChatIcon />
      		<span>{t('LiveChat')}</span>
    	</button>
  	</div>
  );
	};
  const EmailCardContent = ()=><div className="email-content"
          onClick={() => window.open(`mailto:${HelpEmail}`, '_blank', 'noreferrer')}
          style={{ cursor: 'pointer' }}
        >
          {HelpEmail}
        </div>

const PhoneCardContent = ({ t }) => {
	const phoneNumbers = [t('ILPhone'), t('UKPhone'), t('USPhone'), t('PHPhone')].filter((tel) => tel?.trim());

	if (phoneNumbers.length === 0 && t('SupportPhoneNumber')) {
		phoneNumbers.push(t('SupportPhoneNumber'));
	}

  	return (
    <div className="phone-content">
      {phoneNumbers.map((tel, index) => (
        <div
          key={index}
          className="phone-content__item"
          onClick={() => (window.location.href = `tel:${tel}`)}
        >
          {phoneNumbers.length > 1 && <span>{getFlagIconByPhoneNumber(tel)}</span>}
          <span className="phone-item-tel">{tel}</span>
        </div>
      ))}
    </div>
  );
};
  const cards = [
    {
      key: 'phone',
      title: t('CallOurCenters'),
      icon: <PhoneIcon />,
      condition: showPhoneCard,
      render: () => <PhoneCardContent t={t}/>,
    },

    {
      key: 'chat',
      title: t('ChatOnOurPlatform'),
      icon: <ChatIcon />,
      condition: isChatEnabled,
	  render: () => <ChatCardContent t={t}/>      
    },
    {
      key: 'email',
      title: t('EmailUsAt'),
      icon: <EmailIcon />,
      condition: !!HelpEmail,
      render: () => <EmailCardContent t={t}/>
    },
  ];

  return (
    <div className="contact-us-page">
      <div>
        <h1 className="title">{t('ContactUsTitle')}</h1>
        <div className="text">{t('ContactThroughOurChannels')}</div>

        {operatingHours.length > 0 && <div className="operating-hours-container">
          <div className="op-title">
            <OperatingHoursIcon />
            <span>{t('OperatingHours.Title')}:</span>
          </div>
          <div className="body">
            {operatingHours.map((item, index) => (
              <div key={index} className="operatin-hours-row">
      				<Trans i18nKey={item.key} components={{ hours: <Hours /> }} />
              </div>
            ))}
          </div>
          <div className="suffix">{t('OperatingHours.ForUrgentMatters')}</div>
        </div>}
      </div>

      <div className="contact-methods">
		<div className={`contact-methods cards-${cards.length}`}>

        {cards.map(
          (card) =>
            card.condition && (
              <ContactCard key={card.key} icon={card.icon} title={card.title}>
                {card.render()}
              </ContactCard>
            )
        )}</div>
      </div>
    </div>
  );
};

export default withTranslation()(ContactUsPage);